import React, { Component } from 'react';
import { connect } from 'react-redux';

import { dismissStatusMessage } from 'actions/status';

export class Status extends Component {
  componentDidMount() {
    const { messages, dismiss } = this.props;
    messages.forEach(message => {
      setTimeout(() => dismiss(message), 15000);
    });
  }

  render() {
    const { messages, dismiss } = this.props;
    return (
      <div className="messages">
        {messages.map((message, i) => (
          <div className="col-md-12" key={i}>
            <div className="alert alert-success alert-dismissible fade show">
              {message}
              <button
                type="button"
                className="close"
                data-dismiss="alert"
                aria-label="Close"
                onClick={() => dismiss(message)}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
        ))}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  messages: state.status.messages
});

const mapDispatchToProps = dispatch => ({
  dismiss: message => dispatch(dismissStatusMessage(message))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Status);
